import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import { Order, useItemsForOrderLazyQuery } from 'src/graphql/report-service/generated/operations';
import { reportServiceClient } from 'src/utils/graph-clients';
import ItemsForOrder from './items';

const OrderRowDetails = function ({ order, open }: { order: Order; open: boolean }) {
  const [queryForItems, { data, loading }] = useItemsForOrderLazyQuery({
    client: reportServiceClient,
  });

  useEffect(() => {
    if (open) {
      queryForItems({ variables: { orderId: order.id } });
    }
  }, [open]);

  return (
    <Collapse in={open} timeout="auto">
      <Box key={order.id} sx={{ padding: 2 }} data-test-id="items-for-order">
        <ItemsForOrder items={data?.itemsForOrder} loading={loading} />
      </Box>
    </Collapse>
  );
};

export default OrderRowDetails;
